import React from "react"
import {
  MenuScroller,
  MenuTitleH3,
} from "../reusable/menu-slider/menu-slider.styles"
import MenuSlider from "../reusable/menu-slider/menu-slider"
import PropTypes from "prop-types"
import Video from "../reusable/video"

function ActivitiesExplanationMenuSlider({ isOpen, setIsOpen, activity }) {
  return (
    <MenuSlider isOpen={isOpen} setIsOpen={setIsOpen}>
      <Video
        url={"https://www.youtube.com/embed/5zxmIVSKgn4"}
        alt={"Activities video"}
      />
      <MenuScroller>
        {(activity?.includes("Trekking") ||
          activity?.includes("Pilgrimage") ||
          activity?.includes("Walking")) && (
          <p>
            <MenuTitleH3>Hiking Tours</MenuTitleH3>
            Hiking tours are the most popular way to travel, allowing you to
            experience a destination in the most immersive way possible. From
            self-guided treks in remote wilderness areas to guided hikes through
            national parks, our hiking itineraries cater to all skill levels.
          </p>
        )}
        {(activity?.includes("Bike and Cruise") ||
          activity?.includes("E-Bike") ||
          activity?.includes("Gravel biking") ||
          activity?.includes("Mountain Bike") ||
          activity?.includes("Road Bike") ||
          activity?.includes("Biking") ||
          activity?.includes("Standard Biking")) && (
          <p>
            <MenuTitleH3>Bike Tours</MenuTitleH3>
            Bike tours are an amazing way to experience the world, as they offer
            so much variety and the ability to travel at your own pace. With
            high-quality gear and support, you can travel farther, explore
            deeper, and fully enjoy the freedom of two wheels.
          </p>
        )}
        {(activity?.includes("Mountaineering") ||
          activity?.includes("Rock Climbing")) && (
          <p>
            <MenuTitleH3>Climbing Tours</MenuTitleH3>
            Our climbing tours are designed for travellers who love tackling
            challenges at heights. With professional guides and varied routes,
            climbers of all skill levels can experience the exhilaration of
            scaling cliffs and exploring rock formations in the most
            awe-inspiring locations on Earth.
          </p>
        )}
        {(activity?.includes("Biking") || activity?.includes("Walking")) && (
          <p>
            <MenuTitleH3>Family Tours</MenuTitleH3>
            Share the excitement of exploration with the whole family. Family
            tours with 10Adventures are carefully designed to keep all ages
            engaged, safe, and inspired. Enjoy hands-on experiences, gentle
            trails, and family-friendly activities that make traveling together
            a joyful adventure for all.
          </p>
        )}
        {activity?.includes("Multisport") && (
          <p>
            <MenuTitleH3>Multisport Tours</MenuTitleH3>
            If you love variety on your adventures, then 10Adventures multisport
            tours are for you. With a blend of hiking, biking, kayaking, and
            more, these tours are perfect for active travellers who want to keep
            things fresh and exciting with a range of dynamic activities.
          </p>
        )}
        {(activity?.includes("Aurora") ||
          activity?.includes("Gastronomy") ||
          activity?.includes("Self-Drive") ||
          activity?.includes("Soft Adventure")) && (
          <p>
            <MenuTitleH3>Cultural Tours</MenuTitleH3>
            For those who seek a deeper connection with the places they visit,
            our cultural tours offer immersive experiences that go beyond
            sightseeing. Discover local traditions, enjoy authentic meals, and
            engage with the heritage of your destination as you travel beyond
            the guidebook.
          </p>
        )}
        {(activity?.includes("Cross-Country Skiing") ||
          activity?.includes("Downhill Ski") ||
          activity?.includes("Heli-Ski") ||
          activity?.includes("Ice Climbing") ||
          activity?.includes("Ski Touring") ||
          activity?.includes("Snow") ||
          activity?.includes("Snowshoeing")) && (
          <p>
            <MenuTitleH3>Snow Tours</MenuTitleH3>
            From snowshoeing through winter forests to backcountry skiing in
            pristine powder, our snow tours let you experience the beauty of the
            colder months in destinations around the world. These adventures are
            perfect for those who thrive in a winter wonderland!
          </p>
        )}
        {(activity?.includes("Canoe and Kayak") ||
          activity?.includes("Cruise") ||
          activity?.includes("Sailing") ||
          activity?.includes("Scuba diving") ||
          activity?.includes("Snorkeling") ||
          activity?.includes("Surfing")) && (
          <p>
            <MenuTitleH3>Water Tours</MenuTitleH3>
            Experience the world from the water’s edge. Our water tours offer
            kayaking, canoeing, rafting, and more, giving you the chance to
            experience stunning landscapes from an entirely new perspective.
          </p>
        )}
        {activity?.includes("Wellness") && (
          <p>
            <MenuTitleH3>Wellness Tours</MenuTitleH3>
            Sometimes, a good adventure involves slowing down. Our wellness
            tours focus on rejuvenating the mind, body, and spirit in beautiful
            natural settings. With activities like yoga, meditation, and mindful
            hiking, these tours are crafted to leave you feeling refreshed and
            inspired.
          </p>
        )}
        {(activity?.includes("Wildlife") ||
          activity?.includes("Horseback Riding") ||
          activity?.includes("Wildlife Watching") ||
          activity?.includes("Safari")) && (
          <p>
            <MenuTitleH3>Wildlife Tours</MenuTitleH3>
            10Adventures wildlife tours bring you into the heart of the world’s
            most incredible ecosystems, giving you the chance to observe animals
            in their natural habitats. These tours are designed to respect and
            protect wildlife while offering you a rare glimpse into the wonders
            of nature.
          </p>
        )}
      </MenuScroller>
    </MenuSlider>
  )
}

export default ActivitiesExplanationMenuSlider

ActivitiesExplanationMenuSlider.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
  activity: PropTypes.number,
}
